import { Component, inject, OnInit, Renderer2, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Sidebar } from 'primeng/sidebar';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MenubarModule } from 'primeng/menubar';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AvatarModule } from 'primeng/avatar';
import { FileUploadModule } from 'primeng/fileupload';
import { BadgeModule } from 'primeng/badge';
import { LoginHelper } from '../../helpers/login.helper';
import { Subscription } from 'rxjs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { ConfirmationService } from 'primeng/api';
import { DescricaoPadraoModule } from './../../modules/descricao-padrao/descricao-padrao.module';
import { Notificacao } from '../../models/notificacao.model';
import { NotificacaoService } from '../../services/notificacao.service';
import { JwtHelper } from '../../helpers/jwtDecode.helper';
import { GlobalSearchComponent, SearchResult } from './global-search.component';
import { MenuItem } from 'primeng/api';
import { APP_VERSION } from '../../app-version';
import { TooltipModule } from 'primeng/tooltip';
import { limparCacheDoSite } from '../../utils/cache-clear.util';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [
    CommonModule,
    FileUploadModule,
    MenubarModule,
    SidebarModule,
    ButtonModule,
    RippleModule,
    BadgeModule,
    AvatarModule,
    ConfirmDialogModule,
    DescricaoPadraoModule,
    DividerModule,
    GlobalSearchComponent,
    TooltipModule,
  ],
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  nomeUsuario: string = '';
  sidebarVisible: boolean = false;
  notificacoes: Notificacao[] = [];
  logoUrl: string = '/assets/logo/PNG/assinaturaVisual/amarelo.png?v=' + Date.now();
  appVersion: string = APP_VERSION;
  
  loginHelper = inject(LoginHelper);
  authService = inject(AuthService);
  @ViewChild('sidebarRef') sidebarRef!: Sidebar;

  private authStatusSubscription: Subscription;
  items: any[];

  constructor(
    private notificacaoService: NotificacaoService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private renderer: Renderer2,
    private jwtHelper: JwtHelper,
  ) {
    this.items = [
      {
        label: 'Dashboard',
        icon: 'pi pi-home',
        command: () => this.redirectTo('/home')
      },
      {
        label: 'Extratos & Bancos',
        icon: 'pi pi-wallet',
        items: [
          {
            label: 'Importar Extrato',
            icon: 'pi pi-download',
            command: () => this.redirectTo('/importacao-extrato-bancario')
          },
          {
            label: 'Listar Extratos',
            icon: 'pi pi-list',
            command: () => this.redirectTo('/lista-extrato')
          },
          {
            label: 'Adicionar Conta Bancária',
            icon: 'pi pi-plus',
            command: () => this.redirectTo('/conta-bancaria/adicionar')
          },
          {
            label: 'Listar Contas Bancárias',
            icon: 'pi pi-list',
            command: () => this.redirectTo('/conta-bancaria/listar')
          },
          {
            label: 'Lançamentos Caixa',
            icon: 'pi pi-cart-plus',
            command: () => this.redirectTo('/listar-lancamento-caixa')
          }
        ]
      },
      {
        label: 'NFS-e',
        icon: 'pi pi-file-export',
        items: [
          {
            label: 'Emitir NFS-e',
            icon: 'pi pi-file-export',
            command: () => this.confirmarEmitirNfse()
          },
          {
            label: 'Listar NFS-e',
            icon: 'pi pi-filter',
            command: () => this.redirectTo('/listagem-nfs-e')
          },
          {
            label: 'Importar NFS-e',
            icon: 'pi pi-upload',
            command: () => this.alertaImportarNfseEmitidas()
          },
          {
            label: 'Clientes',
            icon: 'pi pi-users',
            command: () => this.redirectTo('/clientes')
          },
          {
            label: 'Descrição Padrão',
            icon: 'pi pi-align-left',
            command: () => this.redirectTo('/descricao-padrao')
          }
        ]
      },
      {
        label: 'Relatórios',
        icon: 'pi pi-file-excel',
        items: [
          {
            label: 'Faturamento',
            icon: 'pi pi-dollar',
            command: () => this.redirectTo('/faturamento')
          },
          {
            label: 'Balancete',
            icon: 'pi pi-wallet',
            command: () => this.redirectTo('/balancete')
          },
          {
            label: 'Balanço Patrimonial',
            icon: 'pi pi-money-bill',
            command: () => this.redirectTo('/balanco-patrimonial')
          },
          {
            label: 'DRE',
            icon: 'pi pi-check-circle',
            command: () => this.redirectTo('/dre')
          },
          {
            label: 'Razão',
            icon: 'pi pi-file-check',
            command: () => this.redirectTo('/razao')
          }
        ]
      },
      {
        label: 'Contábil',
        icon: 'pi pi-book',
        items: [
          {
            label: 'Distribuição de Dividendos',
            icon: 'pi pi-chart-line',
            command: () => this.redirectTo('/dividendos')
          }
        ]
      },
      {
        label: 'Configurações',
        icon: 'pi pi-cog',
        items: [
          {
            label: 'Plano de Contas',
            icon: 'pi pi-book',
            command: () => this.redirectTo('/plano-de-contas')
          },
          {
            label: 'Dados da Empresa',
            icon: 'pi pi-building',
            command: () => this.redirectTo('/empresa')
          },
          {
            label: 'Sócios',
            icon: 'pi pi-users',
            command: () => this.redirectTo('/socios')
          }
        ]
      },
      {
        label: 'Fiscal',
        icon: 'pi pi-check-square',
        items: [
          {
            label: 'Declarações Fiscais',
            icon: 'pi pi-check-square',
            command: () => this.redirectTo('/listar-declaracoes-fiscais')
          },
          {
            label: 'Histórico de Tributos',
            icon: 'pi pi-history',
            command: () => this.redirectTo('/tributos/historico')
          },
          {
            label: 'Tributos a Pagar',
            icon: 'pi pi-credit-card',
            command: () => this.redirectTo('/tributos/pagar')
          }
        ]
      }
    ];

    this.authStatusSubscription = this.authService.authStatus$.subscribe(
      (status) => {
        if (!status) {
          this.sidebarVisible = false;
        }
      }
    );
  }

  ngOnInit(): void {
    this.carregaListaNotificao();
    this.carregarNomeUsuario();
    // Removido console.log de debug
    // Força a atualização do menu
    setTimeout(() => {
      this.items = [...this.items];
      // Removido console.log de debug
    }, 100);
  }

  carregarNomeUsuario(): void {
    const userId = this.jwtHelper.getUserIdFromToken();

    if (userId) {
      this.authService.obterUsuarioPorId(userId).subscribe({
        next: (user) => {
          this.nomeUsuario = user.nomeEmpresa || 'Usuário';
        },
        error: (error) => {
          console.error('Erro ao carregar usuário:', error);
          this.nomeUsuario = 'Usuário';
        }
      });
    }
  }

  carregaListaNotificao(): void {
    const userId = this.jwtHelper.getUserIdFromToken();
    this.notificacaoService.listaNotificao(userId).subscribe({
      next: (notificacoes) => {
        this.notificacoes = notificacoes;
      },
      error: (error) => {
        console.error('Erro ao carregar notificações:', error);
        this.notificacoes = [];
      }
    });
  }

  marcarComoLida(notificacao: Notificacao) {
    this.notificacaoService.MarcarNotificacaoComoLida(notificacao.id).subscribe({
      next: () => {
        notificacao.estaLida = true;
      },
      error: (error) => {
        console.error('Erro ao marcar notificação como lida:', error);
      }
    });
  }

  removerNotificacao(notificacao: Notificacao, event: any) {
    event.stopPropagation();
    this.notificacaoService.deleteLancamentoCaixa(notificacao.id).subscribe({
      next: () => {
        this.notificacoes = this.notificacoes.filter(n => n.id !== notificacao.id);
      },
      error: (error) => {
        console.error('Erro ao remover notificação:', error);
      }
    });
  }

  getUnreadCount(): number {
    return this.notificacoes?.filter(n => !n.estaLida).length || 0;
  }

  hasUnreadNotifications(): boolean {
    return this.getUnreadCount() > 0;
  }

  marcarTodasComoLidas() {
    const unreadNotifications = this.notificacoes.filter(n => !n.estaLida);
    if (unreadNotifications.length === 0) return;

    unreadNotifications.forEach(notificacao => {
      this.notificacaoService.MarcarNotificacaoComoLida(notificacao.id).subscribe({
        next: () => {
          notificacao.estaLida = true;
        },
        error: (error) => {
          console.error('Erro ao marcar notificação como lida:', error);
        }
      });
    });
  }

  limparTodasNotificacoes() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover todas as notificações?',
      header: 'Limpar Notificações',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.notificacoes.forEach(notificacao => {
          this.notificacaoService.deleteLancamentoCaixa(notificacao.id).subscribe({
            error: (error) => {
              console.error('Erro ao remover notificação:', error);
            }
          });
        });
        this.notificacoes = [];
      }
    });
  }

  toggleReadStatus(notificacao: Notificacao, event: any) {
    event.stopPropagation();
    if (notificacao.estaLida) {
      notificacao.estaLida = false;
    } else {
      this.notificacaoService.MarcarNotificacaoComoLida(notificacao.id).subscribe({
        next: () => {
          notificacao.estaLida = true;
        },
        error: (error) => {
          console.error('Erro ao marcar notificação como lida:', error);
        }
      });
    }
  }

  getNotificationIcon(notificacao: Notificacao): string {
    const titulo = notificacao.titulo?.toLowerCase() || '';
    const conteudo = notificacao.conteudo?.toLowerCase() || '';
    
    if (titulo.includes('erro') || conteudo.includes('erro')) return 'pi-exclamation-triangle';
    if (titulo.includes('sucesso') || conteudo.includes('sucesso')) return 'pi-check-circle';
    if (titulo.includes('importar') || conteudo.includes('importar')) return 'pi-download';
    if (titulo.includes('exportar') || conteudo.includes('exportar')) return 'pi-upload';
    if (titulo.includes('relatório') || conteudo.includes('relatório')) return 'pi-file-excel';
    if (titulo.includes('cliente') || conteudo.includes('cliente')) return 'pi-users';
    if (titulo.includes('extrato') || conteudo.includes('extrato')) return 'pi-wallet';
    if (titulo.includes('nfse') || conteudo.includes('nfse')) return 'pi-file-export';
    if (titulo.includes('urgente') || conteudo.includes('urgente')) return 'pi-exclamation-circle';
    if (titulo.includes('importante') || conteudo.includes('importante')) return 'pi-info-circle';
    
    return 'pi-bell';
  }

  getNotificationTime(notificacao: Notificacao): string {
    return 'Agora mesmo';
  }

  trackByNotificacao(index: number, notificacao: Notificacao): any {
    return notificacao.id;
  }

  ngAfterViewInit() {
    if (this.sidebarRef) {
      this.sidebarRef.onShow.subscribe(() => {
        this.renderer.addClass(document.body, 'sidebar-open');
      });

      this.sidebarRef.onHide.subscribe(() => {
        this.renderer.removeClass(document.body, 'sidebar-open');
      });
    }
  }

  redirectTo(route: string) {
    this.router.navigateByUrl(route);
  }

  deslogar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja sair?',
      header: 'Confirmar Saída',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.authService.logout();
      }
    });
  }

  limparCache(): void {
    this.confirmationService.confirm({
      message: 'Isso remove dados temporários salvos no navegador e recarrega a página. Sua sessão de login será mantida.',
      header: 'Limpar cache',
      icon: 'pi pi-refresh',
      acceptLabel: 'Limpar e recarregar',
      rejectLabel: 'Cancelar',
      accept: () => {
        void limparCacheDoSite();
      }
    });
  }

  confirmarEmitirNfse() {
    this.confirmationService.confirm({
      message: 'Deseja emitir uma nova NFS-e?',
      header: 'Emitir NFS-e',
      icon: 'pi pi-file-export',
      accept: () => {
        this.redirectTo('/emitir-nfse');
      }
    });
  }

  alertaImportarNfseEmitidas() {
    this.confirmationService.confirm({
      message: 'Deseja importar NFS-e emitidas em outros sistemas?',
      header: 'Importar NFS-e',
      icon: 'pi pi-upload',
      accept: () => {
        this.redirectTo('/importacao-nfse-emitidas');
      }
    });
  }

  onSearchResultSelected(result: SearchResult) {
    this.redirectTo(result.route);
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === 'k') {
      event.preventDefault();
      const searchInput = document.querySelector('.global-search-input') as HTMLInputElement;
      if (searchInput) {
        searchInput.focus();
      }
    }
  }

  addToFavorites(action: any) {
    console.warn('addToFavorites is no longer functional as QuickActionsComponent is removed.');
  }

  removeFromFavorites(action: any) {
    console.warn('removeFromFavorites is no longer functional as QuickActionsComponent is removed.');
  }

  loadUserFavorites() {
    console.warn('loadUserFavorites is no longer functional as QuickActionsComponent is removed.');
  }

  ngOnDestroy() {
    if (this.authStatusSubscription) {
      this.authStatusSubscription.unsubscribe();
    }
  }

  onLogoError(event: any) {
    console.error('Erro ao carregar logo:', event);
    setTimeout(() => {
      const img = event.target as HTMLImageElement;
      if (img) {
        img.src = img.src + '?t=' + new Date().getTime();
      }
    }, 1000);
  }

  onLogoLoad(event: any) {
  }
}

